import { render, staticRenderFns } from "./UserCreateContainer.vue?vue&type=template&id=dfd141c0"
import script from "./UserCreateContainer.vue?vue&type=script&lang=js"
export * from "./UserCreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports